<template>
  <div>
    <div v-html="$t('welcome.text')"></div>
    <!--<hr class="mt-5" />-->
    <b-form-group class="mt-5" >
      <b-button class="float-right" @click="nextHandler">{{
        $t("welcome.next")
      }}</b-button>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "ViewInstructions",
  methods: {
    nextHandler() {
      this.$specs.withInstructions
        ? this.$router.push("/instructions")
        : this.$specs.tanProtected
        ? this.$router.push("/tan")
        : this.$specs.registrationNeeded
        ? this.$router.push("/register")
        : this.$router.push("/vip")
    },
  },
}
</script>